// extracted by mini-css-extract-plugin
export default {"modal":"C70gBVN5mmTSCZldGdwH"};